module.exports = __webpack_public_path__ + "static/img/is.2ce20c50.svg";